import { ChangeDetectionStrategy, Component, ContentChild, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import type { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import * as FlatModels from '@medsurf/flat-models';

@Component({
    selector: 'medsurf-design-form-control-input-number',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './number.input.form-control.design.html',
    styleUrls: ['./number.input.form-control.design.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    standalone: false
})
export class NumberInputFormControlDesign implements OnInit, OnChanges {
  @Input() formField = true;
  @Input({ required: true }) control!: AbstractControl;
  @Input() inputClass: FlatModels.TextDesignModels.TextDesignClass = FlatModels.TextDesignModels.TextDesignClass.DEFAULT;
  @Input() placeholder = "";
  @Input() label?: string;
  @Input() inputGroup = false;
  @Input() disabled = false;
  @Input() useGrouping = false;
  @Input() showButtons = true;
  @Input() min = Number.MIN_SAFE_INTEGER;
  @Input() max = Number.MAX_SAFE_INTEGER;
  @Input() buttonLayout = 'stacked';
  @Input() incrementButtonIcon = FlatModels.ButtonDesignModels.ButtonDefaultIcons.PLUS;
  @Input() decrementButtonIcon = FlatModels.ButtonDesignModels.ButtonDefaultIcons.MINUS;
  @Output() valueChange = new EventEmitter<Event>();
  
  @ContentChild('content') content?: ElementRef;
  
  name!: string;

  ngOnInit() {
    const formGroup = this.control.parent?.controls as unknown as { [id: string]: AbstractControl };
    let name = undefined;
    if (formGroup) {
      name = Object.keys(formGroup).find(name => this.control === formGroup[name]);
    }
    if (name !== undefined) {
      this.name = name;
    } else {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.form_control_name_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatDesign.NumberInputFormControlDesign.ngOnInit"
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled']?.currentValue) {
      this.control?.disable();
    } else {
      this.control?.enable();
    }
  }
}
